import { grayPalette, greenPalette, redPalette, yellowPalette, royalBluePalette } from '../../themes/colors';
import { opacity } from '../../utils';

export const NotificationLightTheme = {
  borderColor: grayPalette[300],
  backgroundColor: grayPalette[0],
  shadowFrom: opacity(grayPalette[1000], 15),
  shadowTo: opacity(grayPalette[1000], 5),
  success: {
    accentColor: greenPalette[600],
    iconColor: greenPalette[600],
  },
  info: {
    accentColor: grayPalette[500],
    iconColor: grayPalette[700],
  },
  warning: {
    accentColor: yellowPalette[600],
    iconColor: yellowPalette[600],
  },
  danger: {
    accentColor: redPalette[600],
    iconColor: redPalette[600],
  },
  progress: {
    accentColor: royalBluePalette[1000],
    iconColor: royalBluePalette[1000],
  },
};
